module.exports = __webpack_public_path__ + "img/article2.92e19a74.jpg";